<template>
  <div class="i-cell-value">
    <span v-if="item.is_referenced">
      <a
        @click.prevent="showModal = true"
        href="#"
        class="ac_link_cell i-state-clickable"
        aria-label="References"
      >
        <i class="fa5 fas fa-puzzle-piece fav_icon" name="puzzle-piece"></i>
        <span>{{ LANG.references }}</span>
      </a>
    </span>
    <span v-else class="ac_link_cell" aria-label="Not referenced">
      <i class="fa5 fas fa-unlink fav_icon" name="unlink" />
      <span>{{ LANG.notReferenced }}</span>
    </span>

    <ModalReferences
      :document="item"
      :variant="this.item.master ? '' : this.item.url"
      v-model:show="showModal"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import ModalReferences from './ModalReferences.vue';

export default defineComponent({
  inheritAttrs: false,
  components: {
    ModalReferences,
  },
  props: {
    item: Object,
  },
  computed: {
    ...mapState(['LANG']),
  },
  data() {
    return {
      showModal: false,
    };
  },
});
</script>
